import { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';

import CustomTable from './Table';

const PaymentResultList = ({
  payments = [],
  onEdit = () => {},
  onDelete = () => {},
  ...rest
}) => {
  const [page, setPage] = useState(0);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };
  return (
    <Card {...rest}>
      <CustomTable
        data={payments}
        dataKeysSequence={[
          'amount',
          'date',
          'payment_month_year',
          'mode_of_payment',
          'actions'
        ]}
        headers={[
          'Amount',
          'Date',
          'Payment for the month',
          'Mode of payment',
          'Actions'
        ]}
        handlePageChange={handlePageChange}
        page={page}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Card>
  );
};

PaymentResultList.propTypes = {
  payments: PropTypes.array.isRequired
};

export default PaymentResultList;
